import React from "react";
import "./gallery.css";

const spaces = [
  {
    key: 1,
    src:
      "https://s3-ap-southeast-2.amazonaws.com/parameterspace.arup.digital/spaces/8964c02a-dc1a-47ce-b1d5-705d2ef00355/images/Archheight25_InclinationTouching_StabilitysystemVierendeel_HangerconfigurationStraight_ArchshapeParabolic_DeckmaterialConcrete.png",
    link: "/featured-spaces/8964c02a-dc1a-47ce-b1d5-705d2ef00355",
    title: "SHB",
    description: { Author: "Stijn Joosten" }
  },
  {
    key: 2,
    src:
      "https://s3-ap-southeast-2.amazonaws.com/parameterspace.arup.digital/spaces/aae30e59-c84f-4cb1-97e8-826b4cd5a6ca/images/Orientation0_GlazingSHGCVLT0_SillHeight0_HeadHeight0_SectionDiagram.png",
    link: "/featured-spaces/aae30e59-c84f-4cb1-97e8-826b4cd5a6ca",
    title: "1.0A - 80 Ann St [C]",
    description: { Author: "Bianca Toth" }
  },
  {
    src:
      "https://s3-ap-southeast-2.amazonaws.com/parameterspace.arup.digital/spaces/a03510f3-93e0-4b63-bd7a-781956f6e1c9/images/GeoNorthL2_VLT0.45_GlazingRatio0.5.png",
    link: "/featured-spaces/a03510f3-93e0-4b63-bd7a-781956f6e1c9",
    title: "CSU",
    description: { Author: "Jess Watts" }
  },
  {
    src:
      "https://s3-ap-southeast-2.amazonaws.com/parameterspace.arup.digital/spaces/2fda2dad-e450-46b4-b19d-18b441f074bd/images/Height11_Height21.png",
    link: "/featured-spaces/2fda2dad-e450-46b4-b19d-18b441f074bd",
    title: "Belle",
    description: { Author: "Rick Titulaer" }
  }
];

export default class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridData: spaces
    };
  }

  render() {
    let optionItems = spaces.map(Selection => (
      <div className="col">
        <div className="polaroid">
          <a onClick={ (e) => this.props.handler(e, Selection.link) } >
            <img className="image" width="250px" src={Selection.src} alt="" />
          </a>
          <div className="container">
            <p> <b>{Selection.title}</b> <br/> by {Selection.description.Author}</p>
          </div>
        </div>
      </div>
    ));
    return (
      <div>
        <div className="row">
          <h2>Featured Spaces</h2>
        </div>
        <div className="row">{optionItems}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Gallery/Gallery.js